import React, { useState } from "react";
import { SelectBox } from "devextreme-react/select-box";

const License = () => {
    const [selectedValue, setSelectedValue] = useState(null);

    const options = [
        { id: 1, name: "Option 1" },
        { id: 2, name: "Option 2" },
        { id: 3, name: "Option 3" }
    ];

    return (
      <React.Fragment>
        <div>
            <label className="text-sm mb-1">License</label>
            <SelectBox
                dataSource={options}
                displayExpr="name" // Display text
                valueExpr="id" // Value field
                value={selectedValue}
                onValueChanged={(e) => setSelectedValue(e.value)}
                placeholder="Select an option"
            />
        </div>
      </React.Fragment>
    );
  };
  
export default License;
  
